/* eslint-disable max-classes-per-file */
import {NinchatProperties} from '../../api/types'

const makeKey = (id: NinchatProperties.ObjectID, prefix?: string) => (prefix ? `${prefix}-${id}` : id)

class CacheService {
    private _ids: Set<NinchatProperties.ObjectID> = new Set<NinchatProperties.ObjectID>()

    add<T extends NinchatProperties.ObjectID>(currentId: T, prefix?: string): void {
        this._ids.add(makeKey(currentId, prefix))
    }

    clear(): void {
        this._ids.clear()
    }

    has<T extends NinchatProperties.ObjectID>(currentId: T, prefix?: string): boolean {
        return this._ids.has(makeKey(currentId, prefix))
    }
}

class TimerCacheService {
    private _queueTimes: Map<string, number> = new Map<string, number>()

    get(timerKey: string | undefined, fallbackTime: number): number {
        if (!timerKey) {
            return fallbackTime
        }

        return this._queueTimes.get(timerKey) ?? fallbackTime
    }

    set(timerKey: string | undefined, queueTime: number): void {
        if (!timerKey) {
            return
        }

        if (queueTime === 0) {
            this.clear(timerKey)
            return
        }

        this._queueTimes.set(timerKey, queueTime)
    }

    clear(timerKey?: string): void {
        if (!timerKey) {
            return
        }

        this._queueTimes.delete(timerKey)
    }
}

export const cacheService = new CacheService()
export const timerCacheService = new TimerCacheService()
